module.exports = __webpack_public_path__ + "hbomaxar-static/media/Selena-Chef_logo.8bcd69de.png";